import { render, staticRenderFns } from "./RatingStars.vue?vue&type=template&id=428e3c42&scoped=true"
import script from "./RatingStars.vue?vue&type=script&lang=ts"
export * from "./RatingStars.vue?vue&type=script&lang=ts"
import style0 from "./RatingStars.vue?vue&type=style&index=0&id=428e3c42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428e3c42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('428e3c42')) {
      api.createRecord('428e3c42', component.options)
    } else {
      api.reload('428e3c42', component.options)
    }
    module.hot.accept("./RatingStars.vue?vue&type=template&id=428e3c42&scoped=true", function () {
      api.rerender('428e3c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rating/RatingStars.vue"
export default component.exports